import {ProgressIndicatorCircular} from "pac-ux-components";
import React from "react";

function Loading() {
    return (<div style={{
        width: '1046',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: '0 auto'
    }}>
        <ProgressIndicatorCircular/>
    </div>);
}

export default Loading;